import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Company } from 'src/app/models/data/company';
import { Role, RoleDataItem } from 'src/app/models/data/role';
import { Mode } from 'src/app/models/model';
import { ApiService, QueryParam } from 'src/app/services/api.services';
import { CompanyRolesTableComponent } from '../../../../components/company-roles-table/company-roles-table.component';

@Component({
	selector: 'app-company-roles',
	templateUrl: './company-roles.component.html',
	styleUrls: ['./company-roles.component.css', '../../../common/main.scss'],
	imports: [CompanyRolesTableComponent],
})
export class CompanyRolesComponent {
	readonly companyId: string;

	@Input() company?: Company;

	constructor(
		private readonly route: ActivatedRoute,
		private readonly apiService: ApiService,
		private readonly router: Router
	) {
		this.companyId = this.route.snapshot.params.id;
	}

	onRoleSelected(event: { role: Role; mode: Mode }): void {
		this.router.navigate(
			[`/company/${this.companyId}/detail/role/${event.role.id}/detail`],
			{
				state: {
					role: event.role,
					mode: event.mode,
					company: this.company,
				},
			}
		);
	}

	getCompanyRolesByCompanyId = async (
		queryParams: QueryParam[]
	): Promise<RoleDataItem[]> => {
		return await this.apiService.getCompanyRolesByCompanyId(
			this.companyId,
			queryParams
		);
	};
}
